import { css, jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import MyAccount from '@/src/account/components/MyAccount';
import SubscriptionManagement from '@/src/account/components/subscription-preferences/SubscriptionManagement';
import DesignPage from '@/src/cms/models/DesignPage';
import AdminLink from '@/src/shared/components/AdminLink';
import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import withAuthentication from '@/src/shared/components/WithAuthentication';
import request from '@/utils/axios';

const SubscriptionPreferences = props => {
  const { messageData = {} } = props;
  const [pagedata, setPageData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchDesignPage = async () => {
    const response = await request({
      url: `cms/designpage`,
      params: {
        alias: 'subscription-preferences',
      },
    });
    const { data } = response;
    setPageData(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchDesignPage();
  }, []);

  if (loading) {
    return null;
  }

  const page = new DesignPage({ ...pagedata, ...messageData });

  return (
    <Layout>
      <AdminLink pageID="515" pageType="core" />
      <Section bgColor="gray" halfPad>
        <Container>
          <MyAccount mainContent={<SubscriptionManagement pagedata={page} />} />
        </Container>
      </Section>
      <WebLogImage path="/account/subscription-preferences" pagedata={pagedata} />
    </Layout>
  );
};

export default withAuthentication(SubscriptionPreferences);
